<template lang='pug'>
  .apply-promo
    slot
</template>

<script lang='js'>
  export default {
    props: ['promoId'],
    
    data() {
      return {
        res: {},
        error: {}
      }
    },

    mounted() {
      var self = this;
      self.$http.post('/api/cart/applyPromo', {
        promo: {
          id: self.promoId
        }
      }).then(res => {
        self.res = res.data;
        self.$emit('applied', self.res);
      }).catch(err => {
        self.error = err.response;
        self.$emit('error', self.error);
      });
    }
  }
</script>
